import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Scooter parado días enteros esperando turno en el técnico por algo que quizás es simple', 'Videos de YouTube en inglés que no aplican a tu modelo ni a tus condiciones de uso', 'Pinchazos en el peor momento porque nunca sabés cuándo revisar la presión', 'Batería que dura cada vez menos y no sabés si es normal o si hay que cambiarla', 'Ruidos raros que ignorás hasta que se rompe algo más grave (y más caro)', 'El scooter parado en casa, vos sin movilidad, esperando que "alguien lo vea"', 'Plata gastada en service por fallas que con este eBook hubieras resuelto en 15 minutos'];
  return <section className="py-20 px-4 bg-surface/30" data-id="element-189">
      <div className="max-w-4xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-191">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 text-white" data-id="element-192">
            ¿Cuánta plata más vas a gastar en service sin entender qué le pasa?
          </h2>
          <p className="text-lg text-muted mb-8" data-id="element-193">
            Tenés un scooter eléctrico. Te cambió la vida para movilizarte. Pero
            nadie te dijo que ibas a pasar horas buscando en YouTube videos en
            inglés que no aplican a tu modelo, llevando el scooter al técnico
            por cosas que podrías resolver vos, y gastando fortunas en
            reparaciones que ni entendés si eran necesarias.
          </p>
          <div className="inline-block bg-danger/10 border border-danger/20 text-danger font-bold px-6 py-3 rounded-lg text-xl" data-id="element-194">
            No es ignorancia. Es falta de un sistema.
          </div>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-195">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-surface border border-border p-4 rounded-xl" data-id="element-196">
              <XCircle className="text-danger shrink-0 mt-0.5" size={24} data-id="element-197" />
              <p className="text-gray-300 text-lg" data-id="element-198">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-199">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-brand" data-id="element-200">
            ¿Y si este fuera el último service innecesario que pagás?
          </h3>
        </motion.div>
      </div>
    </section>;
}